(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Manager = {
        checkWatchlistAccess: function() {
            try {
                if (typeof window.AuthAPI !== 'undefined' && typeof window.AuthAPI.getStoredSession === 'function') {
                    const session = window.currentSession || window.AuthAPI.getStoredSession();
                    if (session) {
                        return { allowed: true };
                    }
                }
            } catch (e) {
                console.warn('Error checking session auth state via AuthAPI:', e);
            }

            let isLoggedIn = false;
            try {
                const sessionStr = localStorage.getItem('auth_session');
                if (sessionStr) {
                    const sessionItem = JSON.parse(sessionStr);
                    // Standard getCacheItem logic: value is inside .value, and we check .expiry
                    const session = sessionItem.value || sessionItem;
                    const expiry = sessionItem.expiry;
                    if (session && (!expiry || Date.now() < expiry)) {
                        isLoggedIn = true;
                    }
                }
            } catch (e) {
                console.error('Error checking login status', e);
            }
            return {
                allowed: isLoggedIn
            };
        },

        enterWatchlistMode: async function (shouldLoadDefault = true) {
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }
            const access = this.checkWatchlistAccess();

            if (!access.allowed) {
                const message = 'Log in to access watchlist';
                if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                    window.WatchlistApp.Popup.showNotificationPopup('Watchlist Access', message);
                }
                return;
            }
            const Utils = window.WatchlistApp.Utils;
            const State = window.WatchlistApp.State;
            const watchlistViewToggle = document.querySelector('.watchlist-view-toggle-container');
            const watchlistControls = document.querySelector('.watchlist-controls-container');
            const watchlistSummary = document.querySelector('.player-left-column .watchlist-summary');
            // const chartNavArrows = document.querySelector('.chart-nav-arrows');
            const extraButtons = document.querySelector('.extra-buttons-container');

            document.body.classList.add('watchlist-mode');

            if (watchlistSummary) Utils.toggleElementDisplay(watchlistSummary, true, 'flex');

            if (State.currentView === 'table') {
                document.body.classList.add('table-view');
                if (watchlistControls) watchlistControls.classList.add('table-view');
            } else {
                document.body.classList.remove('table-view');
                if (watchlistControls) {
                    watchlistControls.classList.remove('table-view');
                }
            }

            Utils.toggleElementDisplay(watchlistViewToggle, true, 'flex');
            Utils.toggleElementDisplay(watchlistControls, true, 'flex');
            // Utils.toggleElementDisplay(chartNavArrows, true, 'flex');
            Utils.toggleElementDisplay(extraButtons, false);

            window.PreloaderManager?.show();
            try {
                let userId = null;
                let watchlists = [];

                const status = await this.updateWatchlistState();
                if (status.authRevoked) return;
                watchlists = status.watchlists;
                userId = status.userId;

                await this.populateWatchlistDropdown(watchlists, userId, shouldLoadDefault);

                if (watchlists.length === 0) {
                    this.showEmptyWatchlistOverlay();
                } else {
                    this.hideEmptyWatchlistOverlay();
                    const self = this;
                    const checkEmptyAfterLoad = function handler(e) {
                        document.body.removeEventListener('watchlist-data-loaded', handler);
                        const stockInfo = e.detail?.stockInfo || [];
                        const totalStocks = e.detail?.totalStocks || stockInfo.length || 0;
                        if (totalStocks === 0) {
                            self.showEmptyWatchlistOverlay(true);
                        }
                    };
                    document.body.addEventListener('watchlist-data-loaded', checkEmptyAfterLoad);
                }

                State.currentPage = 0;
                this.updateNavArrows();
            } finally {
                window.PreloaderManager?.hide();
            }
        },

        populateWatchlistDropdown: async function (watchlists, userId, shouldLoadDefault = false) {
            const Utils = window.WatchlistApp.Utils;
            const State = window.WatchlistApp.State;
            const watchlistDropdownMenu = document.getElementById('watchlist-selector-menu');
            const watchlistDropdownLabel = document.getElementById('watchlist-selector-label');
            const watchlistDropdown = document.getElementById('watchlist-selector');

            if (watchlistDropdownMenu) {
                watchlistDropdownMenu.innerHTML = '';

                if (watchlists.length > 0) {
                    watchlists.forEach((wl, index) => {
                        const item = document.createElement('div');
                        item.className = 'dropdown-item';

                        const isActive = State.currentWatchlistId ? (wl.id === State.currentWatchlistId) : (index === 0);
                        if (isActive) item.classList.add('active');

                        item.setAttribute('data-value', wl.id);
                        Utils.toggleElementDisplay(item, true, 'flex');
                        item.style.alignItems = 'center';
                        item.style.justifyContent = 'space-between';

                        const nameSpan = document.createElement('span');
                        nameSpan.textContent = Utils.truncateName(wl.name, 20);
                        nameSpan.style.flexGrow = '1';
                        item.appendChild(nameSpan);
                        const deleteBtn = document.createElement('img');
                        deleteBtn.className = 'delete-watchlist-btn';
                        deleteBtn.src = 'desktop_assets/main-block/trash.svg';
                        deleteBtn.title = 'Delete Watchlist';
                        deleteBtn.addEventListener('click', async function (e) {
                            e.stopPropagation();
                            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showConfirmationPopup) {
                                window.WatchlistApp.Popup.showConfirmationPopup(
                                    'Delete Watchlist?',
                                    `Are you sure you want to delete "${wl.name}"?<br>This action cannot be undone.`,
                                    'Delete',
                                    async () => {
                                        await window.WatchlistApp.Manager.deleteWatchlist(wl.id);
                                    },
                                    'Cancel',
                                    null,
                                    'btn-tertiary-negative',
                                    'cancel-popup-btn'
                                );
                            } else {
                                if (confirm(`Delete "${wl.name}"?`)) {
                                    await window.WatchlistApp.Manager.deleteWatchlist(wl.id);
                                }
                            }
                        });
                        item.appendChild(deleteBtn);

                        item.addEventListener('click', function (e) {
                            e.stopPropagation();
                            const label = nameSpan.textContent;

                            if (watchlistDropdownLabel) watchlistDropdownLabel.textContent = label;

                            const allItems = watchlistDropdownMenu.querySelectorAll('.dropdown-item');
                            allItems.forEach(i => i.classList.remove('active'));
                            this.classList.add('active');

                            if (watchlistDropdown) watchlistDropdown.classList.remove('active');

                            window.WatchlistApp.Manager.loadWatchlistData(userId, wl.id);
                        });

                        watchlistDropdownMenu.appendChild(item);
                    });

                    const currentWl = watchlists.find(w => w.id === State.currentWatchlistId) || watchlists[0];
                    if (watchlistDropdownLabel) watchlistDropdownLabel.textContent = Utils.truncateName(currentWl.name, 20);
                    
                    if (shouldLoadDefault) {
                        this.loadWatchlistData(userId, watchlists[0].id, [], null, true, false);
                    }

                } else {
                    if (watchlistDropdownLabel) watchlistDropdownLabel.textContent = 'No Watchlists';
                    if (shouldLoadDefault || !State.allWatchlists || State.allWatchlists.length === 0) {
                        this.clearWatchlistData();
                    }
                }
            }
        },

        clearWatchlistData: function () {
            const Utils = window.WatchlistApp.Utils;
            const State = window.WatchlistApp.State;
            const Table = window.WatchlistApp.Table;
            const Summary = window.WatchlistApp.Summary;

            State.currentWatchlistId = null;
            State.currentWatchlistData = [];
            State.setCurrentWatchlistStockCount(0);
            State.lastReportData = null;

            const centerPanelContent = document.getElementById('large-center-panel-content');
            if (centerPanelContent) {
                centerPanelContent.replaceChildren();
            }

            const stockCube = document.getElementById('stock-3d-cube');
            if (stockCube) {
                const activeIntervalBtn = document.querySelector('#main-block .time-range-wrapper .item.active');
                const currentInterval = (activeIntervalBtn && activeIntervalBtn.getAttribute('data-range')) || (typeof getCacheItem !== 'undefined' ? getCacheItem('data-interval') : null) || '1d';
                stockCube.setAttribute('stock-cube-visualizer', {
                    dataSource: 'watchlist-reports',
                    interval: currentInterval.toLowerCase(),
                    page: 0,
                    topN: State.stocksPerPage,
                    userId: State.currentUserId,
                    watchlistId: null,
                    excludedTickers: [],
                    injectedData: JSON.stringify({ intervals: {}, stockInfo: {} })
                });
            }

            const tableContainer = document.querySelector('.watchlist-table-container');
            if (tableContainer) {
                tableContainer.innerHTML = '<div style="padding: 20px; text-align: center; color: var(--color-text-primary);">No data available</div>';
                Table.renderWatchlistTable(tableContainer);
            }

            const overlayTableContainer = document.querySelector('#edit-watchlist-overlay .overlay-table-container');
            if (overlayTableContainer) {
                Table.renderWatchlistTable(overlayTableContainer, true);
            }

            if (Summary && Summary.calculateAndRenderSummary) {
                const summaries = document.querySelectorAll('.watchlist-summary');
                summaries.forEach(s => Utils.toggleElementDisplay(s, false));
            }
            document.body.dispatchEvent(new CustomEvent('watchlist-data-loaded', {
                detail: {
                    stockInfo: [],
                    totalStocks: 0
                },
                bubbles: true
            }));

            const editOverlay = document.getElementById('edit-watchlist-overlay');
            if (editOverlay) {
                const counter = editOverlay.querySelector('.stock-counter');
                if (counter) counter.textContent = '0 / 50';
            }
        },

        createWatchlist: async function (name, skipViewSwitch = false) {
            if (!name) return;

            if (/[^\x00-\x7F]/.test(name)) {
                return;
            }

            window.PreloaderManager?.show();
            try {
                const res = await WatchlistAPIManager.instance.createWatchlist(name);
                if (res && (res.success || res.id || res.watchlist)) {
                    if (!skipViewSwitch) {
                        await this.enterWatchlistMode(false);

                        const State = window.WatchlistApp.State;
                        const newWatchlist = State.allWatchlists.find(w => w.name === name);
                        if (newWatchlist) {
                            const watchlistDropdownLabel = document.getElementById('watchlist-selector-label');
                            if (watchlistDropdownLabel) watchlistDropdownLabel.textContent = window.WatchlistApp.Utils.truncateName(newWatchlist.name, 20);

                            const watchlistDropdownMenu = document.getElementById('watchlist-selector-menu');
                            if (watchlistDropdownMenu) {
                                const allItems = watchlistDropdownMenu.querySelectorAll('.dropdown-item');
                                allItems.forEach(i => {
                                    if (i.getAttribute('data-value') === newWatchlist.id) {
                                        i.classList.add('active');
                                    } else {
                                        i.classList.remove('active');
                                    }
                                });
                            }

                            this.loadWatchlistData(State.currentUserId, newWatchlist.id, [], null, true, false);
                        }

                        this.showEmptyWatchlistOverlay(true);
                    } else {
                        const data = await WatchlistAPIManager.instance.getWatchlists();
                        if (data && data.watchlists) {
                            const lists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                            window.WatchlistApp.State.allWatchlists = lists;
                        }
                    }
                }
            } catch (e) {
                console.error('[WatchlistManager] Error creating watchlist:', e);
                alert('Failed to create watchlist');
            } finally {
                window.PreloaderManager?.hide();
            }
        },

        deleteWatchlist: async function (id) {
            window.PreloaderManager?.show();
            try {
                const res = await WatchlistAPIManager.instance.deleteWatchlist(id);
                if (res && res.success) {
                    if (document.body.classList.contains('watchlist-mode')) {
                        await this.enterWatchlistMode();
                    } else {
                        await this.updateWatchlistState();
                    }
                }
            } catch (e) {
                console.error('[WatchlistManager] Error deleting watchlist:', e);
                alert('Failed to delete watchlist');
            } finally {
                window.PreloaderManager?.hide();
            }
        },

        loadWatchlistData: async function (userId, watchlistId, excludedTickers = [], intervalOverride = null, renderVisuals = true, showLoader = true) {
            const State = window.WatchlistApp.State;
            State.currentUserId = userId;
            State.currentWatchlistId = watchlistId;

            if (!watchlistId) {
                this.clearWatchlistData();
                return;
            }

            if (showLoader) window.PreloaderManager?.show();

            let currentInterval = intervalOverride;
            if (!currentInterval) {
                const activeIntervalBtn = document.querySelector('#main-block .time-range-wrapper .item.active');
                if (activeIntervalBtn) currentInterval = activeIntervalBtn.getAttribute('data-range');
            }
            if (!currentInterval) {
                currentInterval = (typeof getCacheItem !== 'undefined' ? getCacheItem('data-interval') : null) || '1d';
            }
            currentInterval = currentInterval.toLowerCase();

            try {
                const apiResponse = await WatchlistAPIManager.instance.getWatchlistReports(currentInterval, userId, watchlistId);

                let finalReportData = { intervals: {}, stockInfo: {} };

                if (apiResponse && apiResponse.response && apiResponse.response.data) {
                    const r = apiResponse.response;
                    const headers = r.headers || [];
                    const data = r.data || {};
                    const tickerDetailsMap = r.ticker_info || {};

                    const idxTicker = headers.indexOf('ticker');
                    const idxPrice = headers.indexOf('price');
                    const idxChangePct = headers.indexOf('price_pct_change_vs_prev_close');
                    const idxChange = headers.indexOf('price_change_vs_prev_close');
                    const idxVol = headers.indexOf('volume');
                    const idxRvp = headers.indexOf('daypart_relative_volume_percentage');
                    const idxRanking = headers.indexOf('ranking');

                    Object.keys(data).forEach(timeKey => {
                        const rows = data[timeKey];
                        let cleanTimeKey = timeKey.replace(' EST', '').replace(' EDT', '').trim();
                        cleanTimeKey = cleanTimeKey.replace('T', ' ').replace('Z', '').split('.')[0];

                        finalReportData.intervals[cleanTimeKey] = [];

                        rows.forEach(row => {
                            const ticker = row[idxTicker];
                            if (!ticker) return;

                            if (excludedTickers && excludedTickers.includes(ticker)) return;

                            const price = parseFloat(row[idxPrice]) || 0;
                            const changePct = parseFloat(row[idxChangePct]) || 0;
                            const change = parseFloat(row[idxChange]) || 0;
                            const vol = parseFloat(row[idxVol]) || 0;
                            const rvp = idxRvp !== -1 ? (parseFloat(row[idxRvp]) || 0) : 0;
                            const ranking = idxRanking !== -1 ? (parseInt(row[idxRanking]) || undefined) : undefined;

                            const details = tickerDetailsMap[ticker] || { name: ticker };

                            const stockObj = {
                                ticker: ticker,
                                ranking: ranking,
                                price: price,
                                todaysChangePerc: changePct,
                                todaysChange: change,
                                daypart_relative_volume_percentage: rvp,
                                day: { c: price, v: vol },
                                tickerDetails: {
                                    ...details,
                                    name: details.name || ticker,
                                    primary_exchange: details.primary_exchange
                                },
                                timestamp: timeKey,
                            };

                            finalReportData.intervals[cleanTimeKey].push(stockObj);
                        });
                    });

                    const timeKeys = Object.keys(finalReportData.intervals).sort();
                    const lastTimeKey = timeKeys[timeKeys.length - 1];

                    if (lastTimeKey) {
                        const lastIntervalData = finalReportData.intervals[lastTimeKey];
                        lastIntervalData.forEach(item => {
                            finalReportData.stockInfo[item.ticker] = { ...item };
                        });
                    }

                    finalReportData.metadata = {
                        previous_close_date: Object.values(tickerDetailsMap)[0]?.previous_close_date || ''
                    };

                } else {
                    console.warn('[WatchlistManager] Invalid API response format:', apiResponse);
                }

                const reportStats = apiResponse?.stats;
                State.missingTickersCount = reportStats?.missingTickersCount || 0;
                const wlForStats = State.allWatchlists.find(w => w.id === watchlistId);
                if (wlForStats) {
                    wlForStats.missingTickersCount = State.missingTickersCount;
                }

                const currentWatchlist = State.allWatchlists.find(w => w.id === watchlistId);
                const holdings = currentWatchlist ? currentWatchlist.holdings : {};

                const tickers = Object.keys(finalReportData.stockInfo);

                const applyHoldingToStock = (stockObj, ticker) => {
                    let qty = 0;
                    let totalCost = 0;

                    if (holdings && holdings[ticker]) {
                        qty = parseFloat(holdings[ticker].quantity) || 0;
                        totalCost = parseFloat(holdings[ticker].price) || 0;
                    }

                    stockObj.quantity = qty;
                    stockObj.userHolding = {
                        quantity: qty,
                        price: totalCost
                    };

                    const currentPrice = parseFloat(stockObj.price || stockObj.day?.c || 0);

                    if (totalCost > 0) {
                        const currentTotalValue = currentPrice * qty;
                        const diff = currentTotalValue - totalCost;

                        stockObj.totalChangeDollar = diff;
                        stockObj.totalChangePercent = (diff / totalCost) * 100;
                    } else {
                        stockObj.totalChangeDollar = 0;
                        stockObj.totalChangePercent = 0;
                    }
                };

                tickers.forEach(ticker => {
                    if (!finalReportData.stockInfo[ticker]) return;
                    applyHoldingToStock(finalReportData.stockInfo[ticker], ticker);
                });
                if (finalReportData.intervals) {
                    Object.keys(finalReportData.intervals).forEach(tsKey => {
                        const intervalArr = finalReportData.intervals[tsKey];
                        if (Array.isArray(intervalArr)) {
                            intervalArr.forEach(stockItem => {
                                applyHoldingToStock(stockItem, stockItem.ticker);
                            });
                        }
                    });
                }

                window.WatchlistApp.Summary.calculateAndRenderSummary(finalReportData, holdings, currentInterval);

                const stockCount = Object.keys(finalReportData.stockInfo || {}).length;
                State.setCurrentWatchlistStockCount(stockCount);

                State.lastReportData = finalReportData;
                State.currentWatchlistData = Object.values(finalReportData.stockInfo || {});
                document.body.dispatchEvent(new CustomEvent('watchlist-data-loaded', {
                    detail: {
                        stockInfo: State.currentWatchlistData,
                        totalStocks: stockCount
                    },
                    bubbles: true
                }));

                if (renderVisuals && document.body.classList.contains('watchlist-mode')) {
                    if (typeof addWatchlistReportsCubeToCenterPanel === 'function') {
                        addWatchlistReportsCubeToCenterPanel();

                        const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';
                        const mainChartTitle = document.querySelector('.title-and-date h2');
                        if (mainChartTitle) {
                            mainChartTitle.textContent = window.WatchlistApp.Utils.truncateName(watchlistName, 20);
                        }

                        const stockCube = document.getElementById('stock-3d-cube');
                        if (stockCube) {
                            stockCube.setAttribute('stock-cube-visualizer', {
                                dataSource: 'watchlist-reports',
                                interval: currentInterval,
                                page: 0,
                                topN: State.stocksPerPage,
                                userId: userId,
                                watchlistId: watchlistId,
                                excludedTickers: excludedTickers || [],
                                injectedData: JSON.stringify(finalReportData)
                            });
                        }

                    } else {
                        const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';
                        const mainChartTitle = document.querySelector('.title-and-date h2');
                        if (mainChartTitle) {
                            mainChartTitle.textContent = window.WatchlistApp.Utils.truncateName(watchlistName, 20);
                        }

                        const stockCube = document.getElementById('stock-3d-cube');
                        if (stockCube) {
                            stockCube.setAttribute('stock-cube-visualizer', {
                                dataSource: 'watchlist-reports',
                                interval: currentInterval,
                                userId: userId,
                                watchlistId: watchlistId,
                                excludedTickers: excludedTickers || [],
                                injectedData: JSON.stringify(finalReportData)
                            });
                        }
                    }
                }

            } catch (err) {
                console.error('[WatchlistManager] Error loading watchlist data:', err);
            } finally {
                if (showLoader) window.PreloaderManager?.hide();
            }
        },

        exitWatchlistMode: function (triggerFilterClick = true) {
            const Utils = window.WatchlistApp.Utils;
            const State = window.WatchlistApp.State;

            this.hideEmptyWatchlistOverlay();

            document.body.classList.remove('watchlist-suspended');

            const filtersContainer = document.querySelector('.filters-container');
            const watchlistViewToggle = document.querySelector('.watchlist-view-toggle-container');
            const watchlistControls = document.querySelector('.watchlist-controls-container');
            const watchlistSummary = document.querySelector('.player-left-column .watchlist-summary');
            // const chartNavArrows = document.querySelector('.chart-nav-arrows');
            const extraButtons = document.querySelector('.extra-buttons-container');

            document.body.classList.remove('watchlist-mode');

            const tn = window._tickerNewsInstance;
            if (tn && typeof tn.renderMarketSummary === 'function') {
                tn.currentMode = 'market-summary';
                tn.data.ticker = 'BUSINESS';
                tn.syncFiltersUI('market-summary');
                tn.renderMarketSummary();
                if (tn.container) {
                    tn.container.classList.remove('news-open');
                    const nm = tn.container.querySelector('.news-mode');
                    if (nm) nm.classList.remove('narrative-mode');
                }
            }

            Utils.toggleElementDisplay(filtersContainer, true, 'flex');
            Utils.toggleElementDisplay(watchlistViewToggle, false);
            Utils.toggleElementDisplay(watchlistControls, false);
            if (watchlistSummary) Utils.toggleElementDisplay(watchlistSummary, false);
            // Utils.toggleElementDisplay(chartNavArrows, false);
            Utils.toggleElementDisplay(extraButtons, true, 'flex');

            if (triggerFilterClick) {
                const activeFilter = filtersContainer.querySelector('.item.active');
                if (activeFilter) {
                    if (activeFilter.getAttribute('data-action') !== 'watchlist-reports') {
                        activeFilter.click();
                    } else {
                        const defaultFilter = filtersContainer.querySelector('.item[data-action="topdollar"]');
                        if (defaultFilter) defaultFilter.click();
                    }
                }
            }

            State.currentView = 'chart';
            const chartWrapper = document.querySelector('.chart-wrapper');
            const tableContainer = document.querySelector('.watchlist-table-container');
            const bottomControls = document.querySelector('.bottom-controls');
            const buttonContainers = document.querySelectorAll('.watchlist-table-actions');

            Utils.toggleElementDisplay(chartWrapper, true, 'block');
            Utils.toggleElementDisplay(bottomControls, true, 'block');


            const bottomPlayerArea = document.querySelector('.bottom-player-area');
            const mainControls = document.querySelector('.main-controls');
            if (bottomPlayerArea) Utils.toggleElementDisplay(bottomPlayerArea, true, 'block');
            if (mainControls) Utils.toggleElementDisplay(mainControls, true, 'block');

            if (tableContainer) {
                tableContainer.classList.remove('active');
                Utils.toggleElementDisplay(tableContainer, false);
            }
            buttonContainers.forEach(container => Utils.toggleElementDisplay(container, false));

            const viewBtns = document.querySelectorAll('.view-toggle-buttons .view-btn');
            viewBtns.forEach(b => {
                if (b.getAttribute('data-view') === 'chart') {
                    b.classList.add('active');
                } else {
                    b.classList.remove('active');
                }
            });

            if (watchlistControls) {
                watchlistControls.classList.remove('table-view');
            }
            document.body.classList.remove('table-view');
        },

        suspendWatchlistMode: function() {
            document.body.classList.add('watchlist-suspended');
            const Utils = window.WatchlistApp.Utils;
            const filtersContainer = document.querySelector('.filters-container');
            const watchlistViewToggle = document.querySelector('.watchlist-view-toggle-container');
            const watchlistControls = document.querySelector('.watchlist-controls-container');
            // const chartNavArrows = document.querySelector('.chart-nav-arrows');
            const watchlistTableContainer = document.querySelector('.watchlist-table-container');

            Utils.toggleElementDisplay(watchlistViewToggle, false);
            Utils.toggleElementDisplay(watchlistControls, false);
            // Utils.toggleElementDisplay(chartNavArrows, false);

            if (watchlistTableContainer && watchlistTableContainer.classList.contains('active')) {
                Utils.toggleElementDisplay(watchlistTableContainer, false);
            }
        },

        resumeWatchlistMode: function() {
            document.body.classList.remove('watchlist-suspended');
            const Utils = window.WatchlistApp.Utils;
            const State = window.WatchlistApp.State;

            const watchlistViewToggle = document.querySelector('.watchlist-view-toggle-container');
            const watchlistControls = document.querySelector('.watchlist-controls-container');
            // const chartNavArrows = document.querySelector('.chart-nav-arrows');
            const watchlistTableContainer = document.querySelector('.watchlist-table-container');
            const chartWrapper = document.querySelector('.chart-wrapper');

            Utils.toggleElementDisplay(watchlistViewToggle, true, 'flex');
            Utils.toggleElementDisplay(watchlistControls, true, 'flex');
            // Utils.toggleElementDisplay(chartNavArrows, true, 'flex');

            if (watchlistTableContainer && watchlistTableContainer.classList.contains('active')) {
                Utils.toggleElementDisplay(watchlistTableContainer, true, 'block');
                if (chartWrapper) Utils.toggleElementDisplay(chartWrapper, false);
            } else {
                if (chartWrapper) Utils.toggleElementDisplay(chartWrapper, true, 'block');
            }

            let firstStock = null;
            if (State.currentWatchlistData) {
                if (Array.isArray(State.currentWatchlistData)) {
                    if (State.currentWatchlistData.length > 0) {
                        firstStock = State.currentWatchlistData[0];
                    }
                } else if (typeof State.currentWatchlistData === 'object') {
                    const keys = Object.keys(State.currentWatchlistData);
                    if (keys.length > 0) {
                        firstStock = State.currentWatchlistData[keys[0]];
                    }
                }
            }

            if (firstStock) {
                const scene = document.querySelector('a-scene');
                if (scene) {
                    scene.emit('stock-selected', firstStock);

                    const ticker = firstStock.ticker || firstStock.symbol || firstStock.tickerSymbol || firstStock.T;
                    if (ticker) {
                        const stockChart = document.getElementById('stock-chart');
                        if (stockChart) {
                            const newStockData = {
                                ticker: ticker,
                                todaysChangePerc: firstStock.todaysChangePerc || firstStock.p || 0,
                                todaysChange: firstStock.todaysChange || 0,
                                tickerDetails: {
                                    name: firstStock.name || ticker,
                                    primary_exchange: firstStock.exchange || firstStock.primary_exchange || ''
                                }
                            };
                            stockChart.setAttribute('tradingview-universal-chart', 'stockData', JSON.stringify(newStockData));
                        }
                    }

                    const centerPanelContainer = document.getElementById('center-panel-container');
                    if (centerPanelContainer && (!watchlistTableContainer || !watchlistTableContainer.classList.contains('active'))) {
                        centerPanelContainer.setAttribute('visible', 'true');
                    }
                }
            }
        },

        updateNavArrows: function () {},

        updateWatchlistState: async function () {
            const State = window.WatchlistApp.State;
            let userId = null;
            let watchlists = [];
            try {
                if (typeof window.WatchlistAPIManager === 'undefined') {
                    console.warn('[WatchlistManager] WatchlistAPIManager not ready yet.');
                    return { userId, watchlists };
                }
                const data = await WatchlistAPIManager.instance.getWatchlists(true);
                if (data && data.watchlists) {
                    watchlists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                    userId = data.user_id;
                    State.allWatchlists = watchlists;
                    State.currentUserId = userId;
                }
            } catch (e) {
                console.error('[WatchlistManager] Error fetching watchlists:', e);
            
                if (e && e.message && e.message.includes(' 401')) {
                    console.warn('[WatchlistManager] Server rejected token (401) — clearing local auth state.');
                    try { window.currentSession = null; } catch(_) {}
                    try { localStorage.removeItem('auth_session'); } catch(_) {}
                    try {
                        if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
                            window.AuthUI.updateUI(null);
                        }
                    } catch(_) {}
                    document.dispatchEvent(new CustomEvent('watchlist:auth-changed', {
                        detail: { reason: 'signed_out' }
                    }));
                    return { userId, watchlists, authRevoked: true };
                }
            }
            return { userId, watchlists };
        },

        isPremiumUser: function() {
            // Mock implementation to restrict features to premium users
            return false;
        },

        showEmptyWatchlistOverlay: function (addUnitMode = false) {
            const mainBlock = document.getElementById('main-block');
            if (!mainBlock) return;

            let overlay = document.getElementById('watchlist-empty-overlay');
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.id = 'watchlist-empty-overlay';
                mainBlock.appendChild(overlay);
            }

            overlay.innerHTML = '';

            const bg = document.createElement('div');
            bg.className = 'bg';
            overlay.appendChild(bg);

            const btn = document.createElement('button');
            btn.className = 'watchlist-empty-action-btn';

            const self = this;
            const App = window.WatchlistApp;

            if (addUnitMode) {
                btn.textContent = 'Add unit +';
                btn.addEventListener('click', function () {
                    if (App.Popup && App.Popup.showAddUnitPopup) {
                        App.Popup.showAddUnitPopup({
                            onAdd: async (data) => {
                                const State = App.State;
                                if (!State.currentWatchlistId) return false;
                                try {
                                    const res = await WatchlistAPIManager.instance.addTickersToWatchlist(
                                        State.currentWatchlistId,
                                        [{ ticker: data.ticker, quantity: data.quantity, price: data.price }]
                                    );
                                    if (res && (res.success || res.watchlist)) {
                                        self.hideEmptyWatchlistOverlay();
                                        await self.updateWatchlistState();
                                        await self.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, true, false);
                                        return true;
                                    }
                                } catch (e) {
                                    console.error('[WatchlistManager] Error adding ticker from overlay:', e);
                                }
                                return false;
                            }
                        });
                    }
                });
            } else {
                btn.textContent = 'Create a watchlist';
                btn.addEventListener('click', function () {
                    if (App.Popup && App.Popup.showInputPopup) {
                        const Utils = App.Utils;
                        const uname = Utils && Utils.getCurrentUsername ? Utils.getCurrentUsername() : '';
                        const defaultName = uname ? `${uname}'s watchlist` : 'Watchlist';
                        App.Popup.showInputPopup('Create Watchlist', defaultName, 'Watchlist Name', 'Create', async (newName) => {
                            if (newName) {
                                await self.createWatchlist(newName);
                            }
                        }, { restrictUnicode: true });
                    }
                });
            }

            overlay.appendChild(btn);
        },

        hideEmptyWatchlistOverlay: function () {
            const overlay = document.getElementById('watchlist-empty-overlay');
            if (overlay) {
                overlay.remove();
            }
        }
    };

    window.WatchlistApp.Manager = Manager;

    document.addEventListener('DOMContentLoaded', () => {
        let checks = 0;
        const maxChecks = 100;
        const interval = setInterval(() => {
            checks++;
            if (window.userInitialized || checks >= maxChecks) {
                clearInterval(interval);
                if (window.currentSession) {
                    Manager.updateWatchlistState();
                }
            }
        }, 50);
    });

    let _signedInRefreshTimer = null;

    document.addEventListener('watchlist:auth-changed', (e) => {
        const reason = e.detail?.reason;
        if (reason === 'signed_in') {
            clearTimeout(_signedInRefreshTimer);
            _signedInRefreshTimer = setTimeout(() => {
                Manager.updateWatchlistState().then(({ userId, watchlists }) => {
                    if (!userId || !watchlists.length) return;
                    Manager.populateWatchlistDropdown(watchlists, userId, false);
                    if (document.body.classList.contains('watchlist-mode')) {
                        const State = window.WatchlistApp.State;
                        if (!State.currentWatchlistData || !State.currentWatchlistData.length) {
                            Manager.enterWatchlistMode(true);
                        }
                    }
                }).catch(() => {});
            }, 200);
        } else if (document.body.classList.contains('watchlist-mode')) {
            Manager.exitWatchlistMode();
        }
    });

    document.addEventListener('auth:session-changed', (e) => {
        const session = e.detail.session;
        console.log('[WatchlistApp.Manager] auth:session-changed', { hasSession: !!session });
        if (session && !session.user?.is_anonymous) {
            Manager.updateWatchlistState().then(({ userId, watchlists }) => {
                if (!userId) return;
                Manager.populateWatchlistDropdown(watchlists, userId, false);
            }).catch(() => {});
        }
    });
})();
